import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpdateCurrenciesModal = props => {
  const {
    handleOnClose
  } = props;
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "update-currencies-modal",
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingLabels.multiCurrency.updateCurrencies.title"
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingLabels.multiCurrency.updateCurrencies.description"
        })
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "update-currencies-modal-confirm-button",
        use: "primary",
        onClick: handleOnClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingLabels.multiCurrency.updateCurrencies.confirm"
        })
      })
    })]
  });
};
export default UpdateCurrenciesModal;